export const USER_ID = 11853;

export const DefaultTodo = {
  userId: USER_ID,
  completed: false,
  title: '',
  id: 0,
};
